import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';

import ISettings from './ISettings';

interface IProps {
    settings: ISettings
}

export default class Widget extends React.Component<IProps, void> {
    render() {
        const {settings} = this.props;

        const text = settings.text;

        return (
            <ReactMarkdown source={text} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/basic/text/Widget.tsx